import axios from "../api/axiosInstance";

export const GetAllProvince = async () => {
    return await axios.get("/Province/GetProvinceList");
};

export const GetProvinceById = async (id) => {
    return await axios.get("/Province/GetProvinceById", {
        params: { id }
    });
};

export const AddProvince = async (model) => {
    return await axios.post("/Province/AddProvince", model);
};

export const UpdateProvince = async (model) => {
    return await axios.post("/Province/UpdateProvince", model);
};

export const RemoveProvince = async (id) => {
    return await axios.post("/Province/RemoveProvince", null, {
        params: { id }
    });
};